import axios from '@/axios'
import CONFIG from '@/config'

/**
 * 修改用户信息
 * @param {object} obj
 * @returns
 */
export function updateUser (data) {
  return axios.post('gsg/user/update-user', {
    appCode: CONFIG.APP_CODE,
    ...data
  })
}
/**
 * 上传文件
 * @param {object} obj
 * @returns
 */
export function fileUpload (data) {
  return axios.post('qgsp/upload/image-upload', data, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}
/**
 * 获取用户观看历史记录列表
 * @param {object} obj
 * @returns
 */
export function getPlayRecordList (data) {
  return axios.post('ssg/playrecord/get-play-record-list', {
    appCode: CONFIG.APP_CODE,
    ...data,
    pageNumber: 1,
    pageSize: 500,
    days: 365
  })
}

/**
 * 删除用户某一个历史记录，实际更改用户点播历史的状态，不物理删除
 * @param {string} id
 * @returns
 */
export function removePlayRecord (id) {
  return axios.post('ssg/playrecord/remove-by-id', {
    appCode: CONFIG.APP_CODE,
    id
  })
}

/**
 * 删除用户所有历史记录，实际更改用户点播历史的状态，不物理删除。
 * @param {object} data
 * @returns
 */
export function removePlayRecordAll (data) {
  return axios.post('ssg/playrecord/remove-all', {
    appCode: CONFIG.APP_CODE,
    ...data
  })
}

/**
 * 统计收藏的内容或剧集
 * @param {object} data
 * @returns
 */
export function countFavoriteList (data) {
  return axios.post('qgsp/content/count-favorite-list', {
    appCode: CONFIG.APP_CODE,
    ...data
  })
}

/**
 * 获取收藏的内容或剧集
 * @param {object} data
 * @returns
 */
export function getFavoriteList (data) {
  return axios.post('qgsp/content/list-favorite-list', {
    appCode: CONFIG.APP_CODE,
    ...data
  })
}

/**
 * 删除收藏对象
 * @param {object} data
 * @returns
 */
export function removeFavorite (data) {
  return axios.post('ssg/favorite/remove', {
    appCode: CONFIG.APP_CODE,
    ...data
  })
}

/**
 * 删除收藏对象
 * @param {object} data
 * @returns
 */
export function removeFavoriteAll (data) {
  return axios.post('ssg/favorite/clear-favorite', {
    appCode: CONFIG.APP_CODE,
    ...data
  })
}

/**
 * 用户反馈
 * @param {object} data
 * @returns
 */
export function userFeedback (data) {
  return axios.post('qgsp/feedback/feedback', {
    appCode: CONFIG.APP_CODE,
    ...data
  }, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

/**
 * 获取验证码.有ip黑名单及30秒请求限制
 * @param {object} data
 * @returns
 */
export function sendVerifyCode (data) {
  return axios.post('qgsp/user/send-verifyCode', {
    appCode: CONFIG.APP_CODE,
    ...data
  })
}

/**
 * 换绑前手机号验证.有ip黑名单检测及2秒请求限制
 * @param {object} data
 * @returns
 */
export function verifyUpbind (data) {
  return axios.post('qgsp/user/verify-upbind', {
    appCode: CONFIG.APP_CODE,
    ...data
  })
}

/**
 * 换绑.有ip黑名单检测及2秒请求限制
 * @param {object} data
 * @returns
 */
export function upbindPhone (data) {
  return axios.post('qgsp/user/upbind', {
    appCode: CONFIG.APP_CODE,
    ...data
  })
}

/**
 * 注销用户清除相关数据
 * @param {object} data
 * @returns
 */
export function closeAccount (data) {
  return axios.post('gsg/user/close-account', {
    appCode: CONFIG.APP_CODE,
    apkVersion: CONFIG.VERSION,
    productId: CONFIG.PRODUCT_ID,
    confirm: true,
    deviceCode: 'string',
    deviceType: 'mobile',
    ...data
  })
}

/**
 * 获取BOSS更多鉴权信息
 * @param {object} data
 * @returns
 */
export function getUserAuth (data) {
  return axios.post('ssg/order/auth/more', {
    appCode: CONFIG.APP_CODE,
    ...data,
    productId: 'qgsp'
  })
}
